import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTimer, formatHMS } from '../contexts/TimerContext';
import { Play, Pause } from 'lucide-react';

/**
 * Sticky floating button shown on every admin page when a timer is running/paused.
 * Tap → navigate to /timer for full controls.
 */
const FloatingTimerButton = () => {
  const { timer, liveElapsedSeconds, tick, isActive } = useTimer();
  const navigate = useNavigate();
  const location = useLocation();
  void tick;

  if (!isActive) return null;
  if (location.pathname === '/timer') return null; // already there

  const isRunning = timer.status === 'running';
  const bg = isRunning ? '#10b981' : '#f59e0b';

  return (
    <button
      onClick={() => navigate('/timer')}
      data-testid="floating-timer-btn"
      className="fixed z-50 flex items-center gap-3 rounded-full shadow-2xl text-white font-mono font-semibold px-5 py-3 text-base transition-transform active:scale-95"
      style={{
        bottom: 'max(1rem, env(safe-area-inset-bottom))',
        right: '1rem',
        backgroundColor: bg,
        fontVariantNumeric: 'tabular-nums',
      }}
      aria-label="Open active timer"
    >
      {isRunning ? (
        <Pause className="w-5 h-5" fill="currentColor" />
      ) : (
        <Play className="w-5 h-5" fill="currentColor" />
      )}
      <span>{formatHMS(liveElapsedSeconds)}</span>
      {isRunning && (
        <span
          className="inline-block w-2 h-2 rounded-full bg-white"
          style={{ animation: 'pulse 1.5s infinite' }}
        />
      )}
    </button>
  );
};

export default FloatingTimerButton;
